module.exports = __webpack_public_path__ + "static/mcro-unicorn-logo-24cdacabaf115019db9895d78b862afb.svg";